<template>
  <div id="app" data-app="true" :dir="isRTL" :class="{ 'polish-font': $i18n.locale === 'pl' }">
    <Screen v-if="isScreenVisible" />
    <section class="menus-control">
      <button class="hamburger-btn" @click="toggleSideNav" v-if="!isBlankMode && loggedUser && !isSideNavOpen">
        <img :src="require('@/assets/burger-menu.png')"  alt="menu" />
      </button>
      <button class="close-menu-btn" @click="toggleSideNav" v-if="!isBlankMode && loggedUser && isSideNavOpen">
        <img :src="require('@/assets/close-menu.png')" alt="close" />
      </button>
    </section>
    <Header v-if="!isBlankMode && loggedUser && isSideNavOpen" />
    <!-- inside component there are css properties for print & regular mode -->
    <!-- Hamburger Menu -->
    <section class="view-nav-container">
      <SideNavbar class="side-nav" v-if="(!isBlankMode && loggedUser && isSideNavOpen && sideNavReady)" />
      <FilterCmp v-if="filterOptions"/>
      <section :class="['main', { 'login-main': isLoginPage, 'full-width': !isSideNavOpen, 'overflow-hidden': shouldHideOverflow }]" 
           v-if="isLoginPage || filterOptions">
           <router-view />
      </section>
    </section>
    <WhatsAppPhone />
    <StatsChatPanel v-if="canUseChat && !isLoginPage" />
  </div>
</template>

<script>
import SideNavbar from "./modules/common/components/SideNavbar";
import Header from "./modules/common/components/Header/Header";
import FilterCmp from "./modules/common/components/FilterCmp";
import Screen from "./modules/common/components/Screen";
import WhatsAppPhone from "./modules/common/components/WhatsAppPhone";
import StatsChatPanel from "./modules/performance/components/StatsChatPanel";
import { isPublicAuthRoute } from "./modules/auth/authPublicRoutes";
import { mapGetters } from 'vuex';

export default {
  name: "App",
  data() {
    return {
      isSideNavOpen: true,
      sideNavReady: !!this.$route.name
    };
  },
  async created() {
    await Promise.all([
      this.$store.dispatch({ type: "updateLocale" }),
    ])
  },
  methods: {
    toggleSideNav() {
      this.isSideNavOpen = !this.isSideNavOpen;
    },
  },
  watch: {
    "$route.params.roomId": function () {
      this.$store.dispatch("getRoomById", { id: this.$route.params.roomId });
    },
    $route(to) {
      if (to.name) {
        if (this.sideNavReady) return
        this.sideNavReady = true;
      } else {
        if (!this.sideNavReady) return
        this.sideNavReady = false;
      }
    },
  },
  components: {
    SideNavbar,
    Header,
    Screen,
    FilterCmp,
    WhatsAppPhone,
    StatsChatPanel,
  },
  computed: {
    ...mapGetters(['isBlankMode', 'isScreenVisible', 'loggedUser', 'filterSelected', 'filterOptions']),
    isRTL() {
      return this.$store.getters.isRTL ? "rtl" : "ltr";
    },
    isLoginPage() {
      // Public auth screens render without filterOptions; must include all of them
      // or <router-view> stays unmounted (blank page).
      return isPublicAuthRoute(this.$route.name);
    },
    canUseChat() {
      const user = this.loggedUser;
      if (!user) return false;
      if (user.level === 'buzzz') return true;
      return Array.isArray(user.roles) && user.roles.includes('chat');
    },
    shouldHideOverflow() {
      // Add conditions here, e.g., specific route names
      const routes = ['company', 'site', 'franchise', 'user', 'users', 'shift'];
      return routes.includes(this.$route.name);
    },
  }
};
</script>

<style lang="scss">
@use "@/styles/main.scss";
@use "@/styles/app.scss";
@use "@/styles/vars.scss";
#app {
  &.polish-font {
    // Only applies when the locale is 'pl'
    font-family: vars.$font-main-pl;
  }
}
</style>
